var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99102 0.666992C4.39102 0.666992 0.666016 4.40033 0.666016 9.00033C0.666016 13.6003 4.39102 17.3337 8.99102 17.3337C13.5993 17.3337 17.3327 13.6003 17.3327 9.00033C17.3327 4.40033 13.5993 0.666992 8.99102 0.666992ZM8.99935 15.667C5.31602 15.667 2.33268 12.6837 2.33268 9.00033C2.33268 5.31699 5.31602 2.33366 8.99935 2.33366C12.6827 2.33366 15.666 5.31699 15.666 9.00033C15.666 12.6837 12.6827 15.667 8.99935 15.667ZM8.81602 4.83366H8.76602C8.43268 4.83366 8.16602 5.10033 8.16602 5.43366V9.36699C8.16602 9.65866 8.31602 9.93366 8.57435 10.0837L12.0327 12.1587C12.316 12.3253 12.6827 12.242 12.8493 11.9587C13.0244 11.6753 12.9327 11.3003 12.641 11.1337L9.41602 9.21699V5.43366C9.41602 5.10033 9.14935 4.83366 8.81602 4.83366Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.72a9862d46ca1a6c057d48f31f8e069b.svg";
export { ForwardRef as ReactComponent };